import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IFilterResponse } from 'src/app/core/interfaces/filter-response.interface';
import { IInvoice, IInvoicePayment } from 'src/app/core/interfaces/invoice.interface';
import { IMediaFile } from 'src/app/core/interfaces/media-file.interface';
import { ISentToPartner } from 'src/app/core/interfaces/sent-to-partner.interface';
import { BaseResponse } from 'src/app/core/models/base-response.model';
import { HttpService } from 'src/app/core/services/http.service';

@Injectable({
  providedIn: 'root',
})
export class InvoicesService {
  private readonly http = inject<HttpService>(HttpService);
  private readonly endpoint = 'invoices';

  download(id: string): Observable<BaseResponse<IMediaFile>> {
    return this.http.get<IMediaFile>(`${this.endpoint}/${id}/download`);
  }

  queryInvoice(id: string): Observable<BaseResponse<IInvoice>> {
    return this.http.get<IInvoice>(`${this.endpoint}/${id}`);
  }

  queryInvoices(queryParams: string): Observable<BaseResponse<IFilterResponse<IInvoice>>> {
    return this.http.get<IFilterResponse<IInvoice>>(`${this.endpoint}?${queryParams}`);
  }

  create(invoice: any): Observable<BaseResponse<string>> {
    return this.http.post<any>(this.endpoint, invoice);
  }

  smartBanner(invoiceId: any): Observable<BaseResponse<any>> {
    return this.http.put<any>(`${this.endpoint}/${invoiceId}/smartbanner`, {
      id: invoiceId,
    });
  }

  markAsFavorite(invoiceId: any): Observable<BaseResponse<any>> {
    return this.http.put<any>(`${this.endpoint}/${invoiceId}/favorite`, {
      id: invoiceId,
    });
  }

  update(invoice: any): Observable<BaseResponse<any>> {
    return this.http.put<any>(`${this.endpoint}/${invoice.id}`, invoice);
  }

  delete(id: string): Observable<BaseResponse<any>> {
    return this.http.delete<any>(`${this.endpoint}/${id}`);
  }

  copy(id: string): Observable<BaseResponse<string>> {
    return this.http.post<string>(`${this.endpoint}/${id}/copy`, {});
  }

  processInvoicePayment(data: any): Observable<BaseResponse<any>> {
    return this.http.post<any>(`${this.endpoint}/${data.invoiceId}/payments`, data);
  }

  queryInvoicePayments(
    invoiceId: string,
    queryParams: string,
  ): Observable<BaseResponse<IFilterResponse<IInvoicePayment>>> {
    return this.http.get<IFilterResponse<IInvoicePayment>>(`${this.endpoint}/${invoiceId}/payments?${queryParams}`);
  }

  deleteInvoicePayment(id: string): Observable<BaseResponse<any>> {
    return this.http.delete<any>(`${this.endpoint}/${id}/payments`);
  }

  sentToPartner(data: ISentToPartner): Observable<BaseResponse<any>> {
    return this.http.post<any>(`${this.endpoint}/${data.id}/send-to-partner`, data);
  }
}
